/**
 * Wrap any header content with this component to apply default alignment and styling
 */
import { Box, BoxProps } from '@mui/material';
import classNames from 'classnames';
import React from 'react';

const HeaderItem = (props: BoxProps) => (
  <Box {...props} className={classNames('header-item', props.className)}>
    {props.children}
  </Box>
);

export default HeaderItem;
